import { teamMembers } from '../data/team';
import { useScrollReveal } from '../hooks/useScrollReveal';

const TeamCard = ({ member }) => {
  const [ref, isVisible] = useScrollReveal({ threshold: 0.1 });

  return (
    <article ref={ref} className={`team-card fade-section ${isVisible ? 'is-visible' : ''}`}>
      <figure className="team-card__avatar">
        <img src={member.image} alt={`${member.name}, ${member.role}`} loading="lazy" />
      </figure>
      <div className="team-card__body">
        <h3>{member.name}</h3>
        <span className="team-card__role">{member.role}</span>
        <p>{member.bio}</p>
      </div>
    </article>
  );
};

export const About = () => {
  const [ref, isVisible] = useScrollReveal({ threshold: 0.2 });

  return (
    <section id="about" className="section about-section">
      <div className="container">
        <div ref={ref} className={`section-heading fade-section ${isVisible ? 'is-visible' : ''}`}>
          <span className="section-eyebrow">About Us</span>
          <h2>Led by technologists who love weddings</h2>
          <p>Our team blends product design, engineering, and event planning to deliver seamless digital celebrations.</p>
        </div>
        <div className="team-grid">
          {teamMembers.map((member) => (
            <TeamCard key={member.id} member={member} />
          ))}
        </div>
      </div>
    </section>
  );
};
